// ==================================================================
// CONTENIDO DE LOS CASOS DE EXITO — paginas /casos/<slug>
// El Gato con Copas: completo con la propuesta de marca.
// La Patrona y Burek: estructura preparada, PENDIENTE de que el
// cliente pase las fotos y los textos (marcados abajo).
// ==================================================================

export const CASOS_DETALLE = {
    'el-gato-con-copas': {
        cliente: 'El Gato con Copas',
        sector: 'Hostelería',
        serviciosChips: ['Branding', 'Digitalización', 'Growth Partner'],
        // MARCADOR: propone de valor de la marca — editable por el cliente
        propuestaValor:
            'El Gato con Copas es la taberna donde el carácter mediterráneo se sirve en copa: una marca botánica, cercana y con oficio, que convierte cada visita en un ritual y cada copa en una historia que apetece repetir.',
        propuestaValorAutor: '#PICHONTEAM · Growth Partners',
        antesImg: '/casos/el-gato-logo-antes.jpg',
        brandingImg: '/casos/el-gato-branding.jpg',
        cartaImg: '/casos/el-gato-carta.png',
        paleta: [
            { nombre: 'Verde bosque', hex: '#228922', rgb: '34, 139, 34' },
            { nombre: 'Crema trigo', hex: '#F5DEB3', rgb: '245, 222, 179' },
            { nombre: 'Ocre mediterráneo', hex: '#CC7722', rgb: '204, 119, 34' },
        ],
        // MARCADOR: tipografias oficiales de la marca — sustituir nombre si procede
        tipografia: {
            familia: 'Serif botánica (por confirmar)',
            nota: 'Serif elegante con terminaciones redondeadas para titulares; versalitas espaciadas para etiquetas y carta.',
        },
        proceso: [
            {
                titulo: 'Logo con carácter previo',
                img: '/casos/el-gato-logo-antes.jpg',
                texto: 'La marca original: un gato de silueta negra posado sobre una copa, con el nombre en versalitas. Funcionaba como identificativo, pero no recogía la calidez botánica ni el ambiente de la sala.',
            },
            {
                titulo: 'Nueva propuesta de marca',
                img: '/casos/el-gato-branding.jpg',
                texto: 'Rediseñamos el símbolo con ilustración de mayor detalle y una paleta propia: verde bosque, crema trigo y ocre mediterráneo. Una tipografía serif con carácter redondeado y un estilo que mezcla elementos botánicos, corcho y madera a la deriva.',
            },
            {
                titulo: 'Marca aplicada: la carta',
                img: '/casos/el-gato-carta.png',
                texto: 'La nueva identidad aplicada a la carta: marco dorado, acuarelas de flores y secciones con nombre propio. El resultado da continuidad al estilo de la sala y convierte la carta en parte de la experiencia.',
            },
        ],
        pendiente: false,
    },

    'la-patrona': {
        cliente: 'La Patrona',
        sector: 'Eventos',
        serviciosChips: ['Branding', 'Digitalización', 'SEO & SEM'],
        // MARCADOR: intro del caso — texto del cliente
        intro: 'La Patrona es el ejemplo perfecto de una empresa con una trayectoria impecable en la gestión de personal y catering, cuyo crecimiento se sustentaba históricamente en el boca a boca y la reputación personal de sus fundadores. Nuestro objetivo fue claro: traducir su reputación offline al entorno digital.',
        propuestaValor:
            'La digitalización no debe cambiar quién eres, sino amplificar lo que ya haces bien. La Patrona pasó de depender de referencias a sistematizar su captación: hoy es una opción visible y accesible para el mercado, con una plataforma que respalda su calidad con estética y funcionalidad de vanguardia.',
        propuestaValorAutor: '#PICHONTEAM · Growth Partners',
        resultadoIntro:
            'La transición ha sido un éxito operativo y comercial. La Patrona ha dejado de ser una empresa invisible digitalmente para contar con una plataforma que respalda su calidad con una estética y funcionalidad de vanguardia. La digitalización ha permitido diversificar su cartera de clientes, optimizar el proceso de contratación y, sobre todo, blindar su crecimiento a largo plazo.',
        antesImg: '/casos/la-patrona-logo-antes.webp',
        brandingImg: '/casos/la-patrona-propuesta.png',
        paleta: [
            { nombre: 'Rosa frambuesa', hex: '#E4879F', rgb: '228, 135, 159' },
            { nombre: 'Rosa empolvado', hex: '#F8D8DD', rgb: '248, 216, 221' },
            { nombre: 'Verde jade', hex: '#5B837C', rgb: '91, 131, 124' },
            { nombre: 'Negro cálido', hex: '#2B2828', rgb: '43, 40, 40' },
            { nombre: 'Crema marfil', hex: '#FCF8EF', rgb: '252, 248, 239' },
        ],
        tipografia: {
            familia: 'Montserrat · Lora',
            nota: 'Principal: Montserrat Regular. Secundaria: Lora Regular. Complementaria: Montserrat Light. Claridad contemporánea para la estructura y serenidad serif para los mensajes con emoción.',
            muestras: [
                { fuente: 'Montserrat · Principal', clase: 'font-montserrat' },
                { fuente: 'Lora · Secundaria', clase: 'font-lora' },
            ],
        },
        proceso: [
            {
                titulo: 'Logo con carácter previo',
                img: '/casos/la-patrona-logo-antes.webp',
                texto: 'Una marca con reputación impecable y alta demanda, pero sin presencia digital: el negocio dependía exclusivamente de contactos previos. Ese cuello de botella estratégico dejaba fuera todo el mercado orgánico que buscaba servicios de catering y gestión de eventos en canales digitales.',
            },
            {
                titulo: 'Nueva propuesta de marca',
                img: '/casos/la-patrona-propuesta.png',
                texto: 'El monograma LP, dibujado a trazo sobre su copa característica, se integra en un universo gráfico de acuarelas florales que traslada a digital la elegancia de sus celebraciones. La identidad amplia sus categorías — experiencias, protocolo y servicios corporativos — sin perder el reconocimiento del sello original.',
            },
            {
                titulo: 'Identidad: paleta y tipografía',
                img: '/casos/la-patrona-identidad.png',
                texto: 'Rosa frambuesa, rosa empolvado y verde jade sobre crema marfil, con el negro cálido para el mensaje. Montserrat Regular como tipografía principal, Lora Regular como voz secundaria y Montserrat Light para los matices: un sistema sobrio, cercano y fácil de mantener en cualquier soporte.',
            },
        ],
        ejes: [
            {
                titulo: 'Auditoría y conceptualización',
                texto: 'Comenzamos por estructurar su modelo de negocio. Aunque su know-how era robusto, carecía de una arquitectura web. Definimos la propuesta de valor diferenciadora, convirtiendo su vasta experiencia en el sector en un activo comunicativo claro.',
            },
            {
                titulo: 'Desarrollo de identidad digital',
                texto: 'Diseñamos y desarrollamos una página web corporativa que no solo actúa como un catálogo de servicios, sino como una herramienta de conversión. Implementamos una interfaz intuitiva, optimizada para la conversión de leads y diseñada para transmitir la profesionalidad y la calidad de los servicios de La Patrona.',
            },
            {
                titulo: 'Captación y posicionamiento',
                texto: 'Creamos los canales necesarios para profesionalizar su entrada de clientes. Al pasar de un modelo de captación pasivo (por oídas) a uno activo — búsqueda orgánica y presencia digital —, logramos que la empresa dejara de ser un secreto bien guardado para convertirse en una opción visible y accesible para el mercado general.',
            },
        ],
        pendiente: false,
    },

    'burek': {
        cliente: 'Burek',
        sector: 'Botánica',
        serviciosChips: ['Branding', 'Posicionamiento premium'],
        // MARCADOR: intro del caso — texto del cliente
        intro: 'BUREK es una firma de botánica y floristería premium que combina la sensibilidad artesanal, la creatividad y una estética natural y atemporal. Una marca con personalidad propia, cuyo valor reside en la originalidad de sus composiciones y en una manera singular de entender el diseño floral. Nuestro objetivo fue claro: elevar la percepción de marca a través de una identidad visual más sofisticada, coherente y memorable, sin renunciar a su esencia original.',
        propuestaValor:
            'Las grandes identidades no se reinventan por completo: se perfeccionan para expresar todo lo que siempre han sido. Una marca no necesita perder su esencia para evolucionar; el verdadero valor del branding está en identificar aquello que la hace única y transformarlo en una ventaja competitiva.',
        propuestaValorAutor: '#PICHONTEAM · Growth Partners',
        resultadoIntro:
            'El resultado es una evolución de identidad que conserva el ADN de BUREK mientras eleva su expresión visual hacia un territorio más sofisticado y contemporáneo. El sello original mantiene su protagonismo, ahora integrado en un universo gráfico más equilibrado, elegante y alineado con los valores de la marca: una firma de diseño floral premium que transmite creatividad, artesanía, exclusividad y belleza atemporal. El diseño con sentido.',
        antesImg: '/casos/burek-logo-antes.jpg',
        brandingImg: '/casos/burek-propuesta.png',
        paleta: [
            { nombre: 'Granate botánico', hex: '#821D30', rgb: '130, 29, 48' },
            { nombre: 'Coral suave', hex: '#E47768', rgb: '228, 119, 104' },
            { nombre: 'Verde salvia', hex: '#8FA58C', rgb: '143, 165, 140' },
            { nombre: 'Negro carbón', hex: '#2E2A29', rgb: '46, 42, 41' },
            { nombre: 'Crema marfil', hex: '#F8F0DE', rgb: '248, 240, 222' },
        ],
        tipografia: {
            familia: 'Montserrat · Playfair Display',
            nota: 'Principal: Montserrat Medium. Secundaria: Playfair Display Regular. Complementaria: Montserrat Light. Expresividad de las formas clásicas con la claridad del diseño contemporáneo.',
            muestras: [
                { fuente: 'Playfair Display · Secundaria', clase: 'font-display' },
                { fuente: 'Montserrat · Principal', clase: 'font-montserrat' },
            ],
        },
        proceso: [
            {
                titulo: 'Logo con carácter previo',
                img: '/casos/burek-logo-antes.jpg',
                texto: 'BUREK contaba con un universo visual propio y un elemento distintivo de gran valor: su sello original. El reto no consistía en reinventar la marca desde cero, sino en preservar aquello que la hacía reconocible y desarrollar un lenguaje visual capaz de reflejar con mayor precisión su carácter premium. El equilibrio entre tradición y modernidad, entre artesanía y sofisticación.',
            },
            {
                titulo: 'Nueva propuesta de marca',
                img: '/casos/burek-propuesta.png',
                texto: 'En lugar de sustituir su sello, trabajamos sobre su evolución estética: el monograma BK mantiene su protagonismo, ahora integrado en un universo gráfico más refinado con acuarelas botánicas y el lema que resume su filosofía — botánica premium, diseño con sentido.',
            },
            {
                titulo: 'Identidad: paleta y tipografía',
                img: '/casos/burek-identidad.png',
                texto: 'Una paleta cromática inspirada en tonos botánicos, matices suaves y contrastes delicados, acompañada de una selección tipográfica que equilibra la expresividad de las formas clásicas con la claridad del diseño contemporáneo. Una base visual coherente y versátil, capaz de proyectar el universo creativo de la marca en diferentes soportes.',
            },
        ],
        // Ejes de la estrategia (texto del cliente)
        ejes: [
            {
                titulo: 'Análisis de identidad y preservación del legado',
                texto: 'Partimos de los elementos visuales que definían a BUREK, identificando el valor de su monograma y su sello original como símbolos de reconocimiento. En lugar de sustituirlos, trabajamos sobre su evolución estética, conservando su carácter distintivo y convirtiéndolos en el punto de partida de una identidad más refinada.',
            },
            {
                titulo: 'Rediseño y sofisticación de marca',
                texto: 'Desarrollamos un lenguaje gráfico que combina elegancia, naturalidad y equilibrio. La nueva propuesta incorpora una paleta cromática inspirada en tonos botánicos, matices suaves y contrastes delicados, acompañada de una selección tipográfica que equilibra la expresividad de las formas clásicas con la claridad del diseño contemporáneo. Cada elemento fue concebido para transmitir exclusividad sin perder cercanía, autenticidad ni sensibilidad artesanal.',
            },
            {
                titulo: 'Coherencia visual y posicionamiento premium',
                texto: 'Construimos una propuesta de identidad orientada a reforzar la percepción de calidad y diferenciación de BUREK. Desde el tratamiento del logotipo hasta la definición de colores, tipografías y recursos gráficos, el trabajo establece una base visual coherente y versátil, capaz de acompañar la comunicación de la marca y proyectar su universo creativo en diferentes soportes.',
            },
        ],
        pendiente: false,
    },
};

export const SLUG_POR_CLIENTE = {
    'El Gato con Copas': 'el-gato-con-copas',
    'La Patrona': 'la-patrona',
    'Burek': 'burek',
};

export const slugCliente = (nombre) => SLUG_POR_CLIENTE[nombre] || null;
